// extracted by mini-css-extract-plugin
export default {"items":"orders_items__pjiww"};